import React from 'react'
import DefaultDescriptionField from 'react-jsonschema-form/lib/components/fields/DescriptionField'
import {
  isMultiSelect,
  getUiOptions,
  isFilesArray,
} from 'react-jsonschema-form/lib/utils'

const REQUIRED_FIELD_SYMBOL = '*'

export function Label(props) {
  const { label, required, id, isHTML = false } = props
  if (!label) {
    // See #312: Ensure compatibility with old versions of React.
    return <div />
  }
  const html = {
    __html: '',
  }
  if (isHTML) {
    html.__html = label
    if (required) {
      html.__html += `<span class="required">${REQUIRED_FIELD_SYMBOL}</span>`
    }
  }
  return isHTML ? (
    <label
      key={0}
      className="control-label"
      htmlFor={id}
      dangerouslySetInnerHTML={html}
    />
  ) : (
    <label key={0} className="control-label" htmlFor={id}>
      {label}
      {required && <span className="required">{REQUIRED_FIELD_SYMBOL}</span>}
    </label>
  )
}

export function DefaultLabel({
  schema,
  uiSchema,
  definitions,
  required,
  id,
  name,
  fields = {},
  formContext,
}) {
  const uiOptions = getUiOptions(uiSchema)
  let { label: displayLabel = true } = uiOptions
  if (schema.type === 'array') {
    displayLabel =
      isMultiSelect(schema, definitions) ||
      isFilesArray(schema, uiSchema, definitions)
  }
  if (schema.type === 'object') {
    displayLabel = false
  }
  if (schema.type === 'boolean' && !uiSchema['ui:widget']) {
    displayLabel = false
  }

  const label = uiSchema['ui:title'] || schema.title || name
  const isHTML = uiSchema['ui:options'] && uiSchema['ui:options']['html']
  const description = uiSchema['ui:description'] || schema.description

  const { DescriptionField = DefaultDescriptionField } = fields

  if (displayLabel) {
    return [
      <Label
        key={0}
        label={label}
        required={required}
        id={id}
        isHTML={isHTML}
      />,
      description ? (
        <DescriptionField
          key={1}
          id={id + '__description'}
          description={description}
          formContext={formContext}
        />
      ) : (
        undefined
      ),
    ]
  }

  return null
}

export default Label
